import { flatten } from 'lodash';
import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchUserTemplatesDictionaryRequest = () => ({
  type: actionTypes.FETCH_USER_TEMPLATES_DICTIONARY_REQUEST,
});

export const fetchUserTemplatesDictionarySuccess = (templates) => ({
  type: actionTypes.FETCH_USER_TEMPLATES_DICTIONARY_SUCCESS,
  templates,
});

export const fetchUserTemplatesDictionaryFailure = () => ({
  type: actionTypes.FETCH_USER_TEMPLATES_DICTIONARY_FAILURE,
});

export const fetchUserTemplatesDictionary = (viewType) => async (dispatch) => {
  try {
    dispatch(fetchUserTemplatesDictionaryRequest());

    let allTemplates;
    if (Array.isArray(viewType)) {
      const promises = viewType.map(async (v) => api.fetchUserTemplatesDictionary(v));
      const templates = await Promise.all(promises);
      templates.forEach((item) => {
        allTemplates = { ...allTemplates, ...item };
      });
    } else {
      allTemplates = await api.fetchUserTemplatesDictionary(viewType);
    }
    dispatch(fetchUserTemplatesDictionarySuccess(allTemplates));
  } catch (error) {
    console.error('USER_TEMPLATES_DICTIONARY', error);
    dispatch(fetchUserTemplatesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/user-templates-dictionary.actions.js